import http from '@/apis/utils/request-plugin';

const baseUrl = '/resources/file';

/**
 * 获取文件集访问的token
 * @returns token值
 */
export const getFileSetToken = () => http.get(`${baseUrl}/get-file-set-token`);
